import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatSortModule } from '@angular/material/sort';

import { MgEmptyStateModule } from '@app/src/app/components/EmptyState';
import { MgImageModule } from '@app/src/app/components/MgImage';
import { MgFormFieldModule } from '@app/src/app/form-field';
import { MgIconModule } from '@app/src/app/icon';
import { PermissionsModule } from '@app/src/app/permissions';
import { MgPipesModule } from '@app/src/app/pipes';

import { FormModule } from '@shared/components/form';
import { GenericModule } from '@shared/components/generic';
import { ManagerOverlayModule } from '@shared/components/manager-overlay';
import { MembershipListTableModule } from '@shared/components/membership-list-table';
import { ModalOverlayService, OverlayModule } from '@shared/components/modal-overlay';
import { TextModule } from '@shared/components/text';
import { TooltipModule } from '@shared/components/tooltip';
import { WeekdayToggleModule } from '@shared/components/weekday-toggle';

import { HpmRestrictionsBlackoutEditComponent } from './components/hpm-restrictions-blackout-edit/hpm-restrictions-blackout-edit.component';
import { HpmRestrictionsBlackoutComponent } from './components/hpm-restrictions-blackout/hpm-restrictions-blackout.component';
import { HpmRestrictionsEditComponent } from './components/hpm-restrictions-edit/hpm-restrictions-edit.component';
import { HpmRestrictionsComponent } from './hpm-restrictions.component';
import { HpmRestrictionsGetBlackoutDaysPipe } from './pipes';
import { HpmRestrictionsBlackoutService, HpmRestrictionsService } from './services';

@NgModule({
  imports: [
    // Minga depedencies
    MgIconModule,
    MgEmptyStateModule,
    ManagerOverlayModule,
    OverlayModule,
    PermissionsModule,
    MgEmptyStateModule,
    MgPipesModule,
    MgFormFieldModule,
    MgImageModule,
    FormModule,
    WeekdayToggleModule,
    TooltipModule,
    MembershipListTableModule,
    GenericModule,
    TextModule,

    // External depedencies
    CommonModule,
    FlexLayoutModule,
    MatTableModule,
    MatSortModule,
    MatButtonModule,
    FormsModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatButtonToggleModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatMenuModule,
  ],
  exports: [HpmRestrictionsComponent],
  declarations: [
    // Pipes
    HpmRestrictionsGetBlackoutDaysPipe,

    // Components
    HpmRestrictionsComponent,
    HpmRestrictionsEditComponent,
    HpmRestrictionsBlackoutComponent,
    HpmRestrictionsBlackoutEditComponent,
  ],
  providers: [HpmRestrictionsService, HpmRestrictionsBlackoutService, ModalOverlayService],
})
export class HpmRestrictionsModule {}
